import type { TimeSeriesChartWidget } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import { uuid } from '@piccolohealth/util';
import React from 'react';
import { createModal } from '../../../../components/generic/Modal';
import { TimeSeriesWidgetModalContent } from './TimeSeriesWidgetModalContent';

interface Props {
  participantId: string;
  onAdd: (item: TimeSeriesChartWidget) => Promise<void>;
}

export const TimeSeriesWidgetAddModal = createModal<Props>((props) => {
  const { modal, participantId, onAdd } = props;

  const { visible, hide, remove } = modal;

  const onSubmit = async (widget: TimeSeriesChartWidget) => {
    await onAdd(widget);
    hide();
  };

  const widget: TimeSeriesChartWidget = React.useMemo(
    () => ({
      __typename: 'TimeSeriesChartWidget',
      id: uuid(),
      title: 'New chart',
      series: [],
      phaseChangeLines: [],
      yAxes: {
        left: 0,
        right: null,
      },
    }),
    [],
  );

  return (
    <ChakraV3.Dialog.Root
      open={visible}
      onOpenChange={hide}
      onExitComplete={remove}
      size='cover'
      scrollBehavior='inside'
    >
      <ChakraV3.Dialog.Backdrop />
      <ChakraV3.Dialog.Positioner>
        <ChakraV3.Dialog.Content>
          <ChakraV3.Dialog.Body p={2}>
            <TimeSeriesWidgetModalContent
              participantId={participantId}
              onSubmit={onSubmit}
              widget={widget}
            />
          </ChakraV3.Dialog.Body>
        </ChakraV3.Dialog.Content>
      </ChakraV3.Dialog.Positioner>
    </ChakraV3.Dialog.Root>
  );
});
